import {
  GET_PUBLIC_SKILLS,
  GET_PRIVATE_SKILLS,
  TOGGLE_SKILL,
} from "../actions/types";

const initialState = {
  all_public_skills: [],
  all_private_skills: [],
  skill_loading: false,
};

export default function skillReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PUBLIC_SKILLS:
      return { ...state, all_public_skills: action.payload };
    case GET_PRIVATE_SKILLS:
      return { ...state, all_private_skills: action.payload };
    case TOGGLE_SKILL:
      return { ...state, skill_loading: !state.skill_loading };
    default:
      return state;
  }
}
